// src/components/AppProvider.jsx

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import { ThemeProvider, useTheme } from '../contexts/ThemeContext';
import { LanguageProvider } from '../contexts/LanguageContext';
import { ResetProvider } from '../contexts/ResetContext';
import { ReloadProvider } from '../contexts/ReloadContext';
import { EndPointsProvider } from '../contexts/EndPointsContext';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '../store/store';
import { Provider } from 'react-redux';
import AppRouter from './AppRouter'; // ✅ Import AppRouter instead of AppContent
 
// Loading component while store is rehydrating
const PersistLoading = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
    flexDirection: 'column'
  }}>
    <div style={{
      width: '50px',
      height: '50px',
      border: '4px solid #e0e0e0',
      borderTop: '4px solid #2563eb',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <p style={{ marginTop: '20px', color: '#666' }}>Loading application...</p>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const AppProvider = () => {
  return (
    <Provider store={store}>
      <PersistGate 
        loading={<PersistLoading />} 
        persistor={persistor}
        onBeforeLift={() => {
          console.log('📦 Store rehydration starting...');
        }}
        onAfterLift={() => {
          console.log('✅ Store rehydration complete!');
        }}
      >
        <Router>
          <ThemeProvider>
            <ResetProvider>
              <ReloadProvider>
                <AuthProvider>
                  <EndPointsProvider>
                    <LanguageProvider>
                      {/* ✅ Use AppRouter instead of AppContent */}
                      <AppRouter />
                    </LanguageProvider>
                  </EndPointsProvider>
                </AuthProvider>
              </ReloadProvider>
            </ResetProvider>
          </ThemeProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
};

export default AppProvider;